// Tracks whether the visitor has made at least one in-app (client-side)
// navigation this session, so pages can decide whether browser/programmatic
// Back actually has somewhere within the site to land — as opposed to a
// direct load, bookmark, or an external referrer, where Back would just
// leave the site (or do nothing).
//
// gatsby-browser.js's onRouteUpdate calls recordRouteUpdate() on every route
// change, including the very first page load. That first call is the
// initial load, not a navigation, so hasInternalHistory() only flips true
// once a second call proves the visitor moved from one in-app page to
// another.
let routeUpdateCount = 0;

export const recordRouteUpdate = () => {
  routeUpdateCount += 1;
};

export const hasInternalHistory = () => routeUpdateCount > 1;
